export const ConfigSwitch = ({
  id,
  checked,
  onChange,
  ariaLabel,
  disabled = false,
}) => {
  return (
    <div className="switch-container">
      <input
        id={id}
        type="checkbox"
        role="switch"
        aria-checked={checked}
        checked={checked}
        disabled={disabled}
        onChange={(e) => {
          if (disabled) return;
          onChange(e.target.checked);
        }}
        aria-label={ariaLabel}
      />
    </div>
  );
};
